import { useIcon } from '../Hooks/useIcon';

export default function DynamicIcon(props: any) {
  const Icon = useIcon(props);
  return Icon;
}
